import React from 'react'
import { Spin, message } from 'antd';
import EssaModal from "@components/EssaModal/EssaModal";
import FormFormat from '@/components/FormFormat/FormFormat';
import AuthBtn from "@components/HoverIcon/AuthBtn";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import UploadFile from '@/components/UploadFile/UploadFile'
import Lang from "@components/Lang/Lang";
import { Link } from "react-router-dom"
import {submitRecommend,getRecommendDetail} from '@/api/warehouseManagement/registration'
import LogisticsAndCabinetSwitch from "@/components/Logistics/LogisticsAndCabinetSwitch";
import { toFixedWithCommas} from "@utils/number-util";
import PageCommon from  "@components/PageCommon/PageCommon";
import LogisticsSelect from "./LogisticsSelect/index"
import "./index.less"
import Consignee from "@/components/Consignee/Consignee";//收货人
import TakeAction from "./Table.action";
/**
 * 已清关未入库 表格组件
 *
 * @author FJJ
 * @version 1.0
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
export default class ClearanceTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            loading: false,
            list: [],
            // 表单 配置
            searchFormOptions:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'poCode',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'订单编号',
                    cnPlaceholderId:'DingDanBianHao',
                    // type:'SearchInput',
                    width:256,
                },
                {
                    name:'buyerCode',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'客户编号',
                    cnPlaceholderId:'KeHuBianHao',
                    width:256,
                },
            ],
            // 上传设置
            uploadSetting : {
                name: 'fileClearanceOut',
                accept:'.xlsx, .xls',
                showUploadList: false,
                // customRequest:this.handleUpload.bind(this),
                // beforeUpload:this.beforeUpload.bind(this),
                replace:true,
            },
            columns:[
                {
                    cnTitle: '收货城市',
                    cnTitleId: 'MuDeDiChengShi',
                    dataIndex: 'cityName',
                }, {
                    cnTitle: '客户编号',
                    cnTitleId: 'KeHuBianHao',
                    dataIndex: 'buyerCode',
                    render:(text, record, index) => (
                        record.buyerId?<Link className="num" to={`/customer/detail?id=${record.buyerId}`}>{text}</Link>:text
                    ),
                },
                {
                    cnTitle: 'PO单号',
                    dataIndex: 'poCode',
                    width: 200,
                    cnTitleId: 'PODingDan',
                    render:(code, record, index) => (<>
                        <p className={"black89 font-bold"}>{code}</p>
                        {record.poId&&<LogisticsAndCabinetSwitch poId = {record.poId}
                                                                        poCode={record.poCode}
                                                                        containerCode={record.containerCode}
                                                                        cabinetNum={record.cabinetNum} />}
                    </>)
                },
                {
                    cnTitle: '商品信息',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'ShangPinXinXi',
                    render:  (text, record, index) => (
                        <span>{record.skuCount}{Lang({id:'Kuan', default:'款'})}, {record.totalQuantity}{Lang({id: 'Xiang', default: '箱'})}</span>
                    )
                },
                {
                    cnTitle: '体积重量³',
                    dataIndex: 'totalVolume',
                    cnTitleId: 'TiJiZhongLiang',
                    render: (totalVolume, record) => <div>
                        {/* 数据不控制小数位 后端显示控制即可*/}
                        <span className="content-text mr_2">{totalVolume || "-"}</span>m³,
                        <span className="content-text mr_2">{record.totalGrossWeight|| "-"}</span>kg
                    </div>
                }, {
                    cnTitle: '目的仓库',
                    cnTitleId: 'MuDiCangKu',
                    dataIndex: 'transitCityName',
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 100,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<div >
                        {/* 0:未推荐 1:已推荐 */}
                        <AuthBtn icon={record.isRecommend==1?"ri-hand-coin-line color-green":"ri-hand-coin-line"}
                                 className={record.isRecommend==1?"clearanceTableBgGreen":""}
                                 tips = {record.isRecommend==1?Lang({id:"YiTuiJian",default:"已推荐"}):Lang({id:"WeiTuiJian",default:"未推荐"})}
                                 onClick={()=>this.openModal(true,record)}/>
                    </div>)},
            ],
            // 物流推荐弹窗
            detail:{},
            objLogistics:{}
        }
    }
    openModal(flag=true,row={}) {
        if(flag){
            this.getDetail(row)
        }else {
            this.setState({
                isModalVisible: flag,
            })
        }
    }
    /*
    * 推荐物流公司详情
    * **/
    getDetail(row={}){
        const data = {
            poId: row.poId
        }
        getRecommendDetail(data).then((res={})=>{
            const data = res.data||{}
            const { success,valid,model={} } = data;
            if (success && valid) {
                this.setState({
                    detail: model,
                    objLogistics:model.recommendLogisticsInfo||{},// 推荐公司
                    isModalVisible: true,
                })
            } else if(data.message){
                message.info(data.message);
            }else message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
        })
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }

    fetchBack(data={}){    // 查询回调
        this.onRefPageCommonChild.isShowTop()
        const {success,valid,paging,model={} } = data;
        if(success&&valid&&model){
            this.props.changeNum && this.props.changeNum(model.waitIntoWarehouseCount||0,model.waitIntoNum||0)
        }
    }
    /**
     * 点击确认时 获取表单数据
     ***/
    async handleOK(){
        const res = await this.onRefFormFormat.handleOK();
        if(res&&res.success){
            const values = res.data;
            const { detail,objLogistics } = this.state;

            const data = {
                ...values,
                recommendLogisticsCompanyId: objLogistics.id, // 以此为准
                poId: detail.poId
            }
            submitRecommend(data).then((res={})=>{
                const data = res.data||{}
                const { success,valid,model } = data;
                if (success && valid) {
                    this.onPageTemplateTableChild.handleFetch(1,{},true)
                    this.openModal(false)
                } else if(data.message){
                    message.info(data.message);
                }else message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
            })
        }

    }
    /**
     * 导出
     * http://rap.essa.top:88/workspace/myWorkspace.action?projectId=211#7899
     * */
    onClickExport(){
        this.loading(true);
        const sUrl = "/service/mg/warehouse-management/download-excel";
        TakeAction.commonAction({},sUrl).then(res => {
            this.loading(false)
            const data = res.data||{};
            const {success,valid,model} = data;
            if (success && valid) {
                if(model&&model.fileUrl){
                    window.open(model.fileUrl)
                }else message.info(Lang({id:"ZanWuShuJu",default:"暂无数据"}));
            } else if(data.message){
                message.info(data.message);
            }else message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
        })
    }
    /**
     * 上传填充
     * http://rap.essa.top:88/workspace/myWorkspace.action?projectId=211#7900
     * */
    onClickUpLoad(fileId){
        this.loading(true)
        const sUrl = "/service/mg/warehouse-management/analysis-excel";
        TakeAction.commonAction({
            fileId:fileId
        },sUrl).then(res => {
            this.loading(false);
            const data = res.data||{};
            const {success,valid,model={}} = data;
            if (success && valid) {
                if(model.fail||model.success){
                    message.info(Lang({id:"ChengGongGengXinNTiaoShuJuNTiaoShiBai",default:"成功更新{0}条数据，{1}条失败",params:[model.success,model.fail]}));
                }
               if(this.onPageTemplateTableChild) {
                   this.onPageTemplateTableChild.handleFetch(1,{},true)
               }
            } else if(data.message){
                message.info(data.message);
            }else message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
        })
    }
    /**
     * 上传文件后设置
     * **/
    handleUpload(file=[]){
        if(file.length>0){
            const fileId = file[0].fileId;
            this.onClickUpLoad(fileId)
        }
    }
    // 设置值
    setLogistics(obj={}){
        this.setState({
            objLogistics :obj
        })
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    render() {
        const {loading, columns,searchFormOptions,isModalVisible,detail,uploadSetting,objLogistics } = this.state;
        return (<PageCommon onRef={this.onRefPageCommon}
                            btnList={[{
                                btn: Lang({id:"DaoChu",default:"导出"}),
                                icon:"ri-download-2-line mr_4 color-blue",
                                btnClick:()=>this.onClickExport()
                            },{
                                btn: <UploadFile {...uploadSetting}
                                                 onChange={(fileList)=>{
                                                     this.handleUpload(fileList);
                                                 }}>
                                    <i className='ri-upload-cloud-line color-yellow mr_4'></i> <span style={{color:'#fff'}}>{Lang({id:'ShangChuanTianCong',default:'上传填充'})}</span>
                                </UploadFile>
                            }
                            ]}>
                <Spin spinning={loading}>
                    <AutoFetchTable columns={columns}
                                    onRef={this.onRefTabOne}
                                    flagShowReset={false}
                                    // flagShowSearchBtn={false}
                                    fetchCallBack={(data)=>this.fetchBack(data)}
                                    pageSize={50}
                                    searchFormOptions={searchFormOptions}
                                    fetchApi={'/service/mg/warehouse-management/customs-cleared/wait-into-warehouse-list'} />
                </Spin>

                {isModalVisible&&<EssaModal title={Lang({id:"WuLiuTuiJian",default:"物流推荐"})}
                                            open={isModalVisible}
                                            key={"rx"}
                                            width={600}
                                            onOk={()=>this.handleOK()}
                                            onCancel={()=>this.openModal(false)}>
                    <div className={"clearanceWrap"}>
                        <div className={"mb_4 flex-item-ver-center"}>
                            <span className={"black100 fw_700 font_16"}>{detail.buyerCode}</span>
                            <span className={"black66 ml_12"}>{detail.buyerName}</span>
                        </div>
                        <div className={"black89 fw_700 mb_4"}>{detail.poCode}</div>
                        <div className={"mb_16 flex-item-ver-center"}>
                            <span className={"spanGrey"}>{Lang({id:"NKuanNXiang",default:"{0} 款，{1} 箱",params:[detail.skuCount,detail.totalQuantity]})}</span>
                            <span className={"spanGrey ml_8"}>{detail.totalVolume} m³</span>
                            <span className={"spanGrey ml_8"}>{detail.totalGrossWeight} kg</span>
                        </div>
                        {/* 收货 人 */}
                        <Consignee address={detail.consigneeInfo}  />
                        <div className={"mt_16"}>
                            <FormFormat onRef={this.onRefForm}
                                    formLayout="vertical"
                                    options={[
                                        {
                                            // name:'LogisticsSelect',
                                            name:'recommendLogisticsCompanyId',
                                            cnTitle:'推荐物流公司',
                                            cnTitleId:'TuiJianWuLiuGongSi',
                                            cnPlaceholderId:"QingXuanZeWuLiuGongSi",
                                            cnPlaceholder:'请选择物流公司',
                                            showTitle: true,
                                            type:'OnlyRender',
                                            onlyRender: (<LogisticsSelect list={detail.recommendLogisticsList}
                                                                          onChange={(obj)=>this.setLogistics(obj)}
                                                                          recommendLogisticsInfo={objLogistics}
                                            />),
                                            required: true,
                                        },{
                                            name:'preRecommendPrice',
                                            title: Lang({id:"TianXieYuJiWuLiuFeiYong",default:"填写预计物流费用（{0}）", params:[detail.currencySymbol]}),
                                            pattern:[{pattern: /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/,required:true,
                                                message: Lang({id:"QingShuRuDaYuLingDeShuZi",default:"请输入大于0的数字，最多两位小数"})
                                            }],
                                            type: "Number",
                                            required:true
                                        }
                                    ]}
                                    initialValues={detail}
                        />
                        </div>
                    </div>
                </EssaModal>}
            </PageCommon>
        )
    }
}